/**
 * Инновация, краткое описание
 */
import { Identity } from '@n3/ng-api-common';
import { EntityState } from '@n3/ng-api-common';
import { ClassifierShort } from '@n3/ng-api-common';
import { BaseModel } from '@n3/ng-api-base-kit';

export class InnovationShort extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public identity: Identity; /**/
    public entity_state: EntityState; /**/
    public institution_identity: Identity; /**/
    public name: string; /*Название*/
    public level: ClassifierShort; /**/
    public activity_direction: ClassifierShort; /**/
    public activity_start: string; /*Дата начала деятельности*/
    public activity_end: string; /*Дата окончания деятельности*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.identity = new Identity(json.identity);
        this.entity_state = new EntityState(json.entity_state);
        this.institution_identity = new Identity(json.institution_identity);
        this.name = json.name || null;
        this.level = new ClassifierShort(json.level);
        this.activity_direction = new ClassifierShort(json.activity_direction);
        this.activity_start = json.activity_start || null;
        this.activity_end = json.activity_end || null;
        this._isEmpty = this.isEmpty(this);
    }
}
